import { CheckCircleOutlined } from '@ant-design/icons'
import { Modal } from 'antd'

import Box from '~/core/Box'
import Button from '~/core/Button'
import Text from '~/core/Text'
import getColor from '~/lib/getColor'

const PLACEMENT = 'notift-fictiv-modal'
const MODAL_TITLE = 'Your responses will be reviewed shortly.'
const MODAL_DESCRIPTION =
    'Fictiv has been notified of your request. If your quote is ready to be checked out, you may still do so.'

type NotifyFictivModalPropsType = {
    onClose: () => void
}

const NotifyFictivModal = (props: NotifyFictivModalPropsType) => {
    const { onClose } = props

    return (
        <Modal
            bodyStyle={{ padding: '24px' }}
            centered
            closable={false}
            footer={null}
            onCancel={onClose}
            visible
        >
            <Box>
                <CheckCircleOutlined
                    style={{
                        color: getColor('success'),
                        fontSize: '21px',
                        marginRight: '16px',
                    }}
                />
                <Box direction="col" flex="1">
                    <Text
                        color="blackAlpha65"
                        fontSize="16px"
                        fontWeight={500}
                        style={{ marginBottom: '12px' }}
                    >
                        {MODAL_TITLE}
                    </Text>
                    <Text
                        color="blackAlpha65"
                        style={{
                            marginBottom: '16px',
                        }}
                    >
                        {MODAL_DESCRIPTION}
                    </Text>
                    <Box justifyContent="end">
                        <Button
                            data-test-target={`${PLACEMENT}-cancel`}
                            name={`${PLACEMENT}-cancel`}
                            onClick={onClose}
                            placement={PLACEMENT}
                            style={{ marginLeft: 'auto' }}
                            type="primary"
                        >
                            Close
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}

export default NotifyFictivModal
